export default "__VITE_ASSET__a20a3197__"